

import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { AuthGuard } from './shared/services/auth/auth-guard.service';
import { LayoutComponent } from './contents/shared/layout/layout.component';
import { NotFoundComponent } from './contents/shared/pages/not-found/not-found.component';
import { LandingComponent } from './contents/shared/pages/landing/landing.component';
import { DomainExpiredComponent } from './contents/shared/pages/domain-expired/domain-expired.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'landing',
        pathMatch: 'full'
    },
    {
        path: 'landing',
        component: LandingComponent
    },
    {
        path: 'auth',
        loadChildren: () => import('./contents/auth/auth.module').then(m => m.AuthModule),
    },
    {
        path: 'admin',
        component: LayoutComponent,
        loadChildren: () => import('./contents/admin/admin.module').then(m => m.AdminModule),
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { type: ['admin','adminstaff'] }
    },
    {
        path: 'merchant',
        component: LayoutComponent,
        loadChildren: () => import('./contents/merchant/merchant.module').then(m => m.MerchantModule),
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { type: ['merchant','merchantstaff']}
    },
    {
        path: 'agentunlimited',
        component: LayoutComponent,
        loadChildren: () => import('./contents/agent/agent.module').then(m => m.AgentModule),
        canActivate: [AuthGuard],
        canLoad: [AuthGuard],
        data: { type: ['agentunlimited', 'agentstaffunlimited']}
    },
    { path: 'not-found', component: NotFoundComponent },
    { path: 'domain-expired', component: DomainExpiredComponent },
    { path: '**', component: NotFoundComponent },
];

@NgModule({
    imports: [RouterModule.forRoot(routes)],
    exports: [RouterModule]
})
export class AppRoutingModule {

}

